;(function (angular, _, moment) {
  'use strict'

  angular
    .module('kilo.common.services')
    .service('RubricService', RubricService)

  RubricService.$inject = [
    'RubricManager'
  ]

  function RubricService (RubricManager) {
    var self = this

    _.extend(self, {
      // Methods
      fromPrettyToDb: fromPrettyToDb,
      fromDbToPretty: fromDbToPretty,
      getWidthFromDeep: getWidthFromDeep,

      // To delete
      sortRubrics: sortRubrics,
      getChildren: getChildren,
      getParent: getParent,
      getParentMaxPosition: getParentMaxPosition,
      getMaxPosition: getMaxPosition,
      getPositionLabel: getPositionLabel
    })

    function sortRubrics (rubrics) {
      var todo = angular.copy(rubrics)
      // Get parent rubrics
      var parents = _.filter(rubrics, function (elt) {
        return !elt.parent
      })
      // For each parent, get their respective children and sort them by position
      return _.sortBy(_.map(parents, function (elt) {
        return [elt, _.compact(getChildren(elt, todo))]
      }), function (elt) {
        return elt.position
      })
    }

    function getChildren (rubric, arr) {
      // Get children rubrics
      var children = _.filter(arr, function (elt) {
        if (typeof elt.parent === 'object') return elt.parent._id === rubric._id
        return elt.parent === rubric._id
      })
      // Remove them from the work array
      _.remove(arr, function (elt) {
        return _.includes(children, elt)
      })
      // For each children, get their respective children and sort them by position
      if (children.length) {
        return _.sortBy(_.map(children, function (elt) {
          return [elt, _.compact(getChildren(elt, arr))]
        }), function (elt) {
          return elt.position
        })
      }
    }

    function getParentMaxPosition (parent, rubrics) {
      return _
        .chain(rubrics)
        .filter(function (elt) {
          if (typeof elt.parent === 'string') return elt.parent && elt.parent === parent._id
          return elt.parent && elt.parent._id === parent._id
        })
        .map(function (elt) { return elt.position })
        .max()
    }

    function getMaxPosition (rubrics) {
      return _
        .chain(rubrics)
        .filter(function (elt) { return !elt.parent })
        .map(function (elt) { return elt.position })
        .max()
    }

    function getParent (rubric, sortedRubrics) {
      return _.find(sortedRubrics, function (elt) {
        return elt._id === rubric.parent
      })
    }

    function getPositionLabel (elt, sortedRubrics) {
      var positions = []
      positions.unshift(elt.position)
      while (elt.parent) {
        elt = (typeof elt.parent === 'string') ? getParent(elt, sortedRubrics) : elt.parent
        positions.unshift(elt.position)
      }
      return positions.join('.')
    }

    function getWidthFromDeep (deep) {
      return deep * 30
    }

    // return a pretty array to iterate on rubric (db format to pretty format)
    function fromDbToPretty (rubrics) {
      let data = angular.copy(rubrics)
      let final = []
      if (!rubrics || !rubrics.length) return []
      let sortRecc = (focus, deep, label) => {
        var topLevel = _.filter(data, function (elt) {
          return elt.parent === focus
        })
        if (!topLevel.length)
          return
        topLevel.sort((a, b) => a.position > b.position)
        topLevel.forEach(rub => {
          let cl = label.length ? label + '.' + (rub.position + 1 ) : '' + (rub.position + 1)
          final.push({
            deep: deep,
            label: cl,
            rubric: rub
          })
          sortRecc(rub._id, deep + 1, cl)
        })
      }
      sortRecc(undefined, 0, '')
      return final
    }

    // return a db formated rubrics array (pretty format to db format)
    function fromPrettyToDb (rubrics) {
      let final = []
      let i = 0
      if (!rubrics || !rubrics.length) return []
      const findDescendants = (index = 0, parent = null) => {
        let target = rubrics[index]
        let currentPosition = 0
        final.push(
          {
            _id: target.rubric._id,
            label: target.rubric.label,
            total: target.rubric.total,
            parent: parent,
            position: currentPosition
          })
        for (i = index + 1; i < rubrics.length; i++) {
          if (rubrics[i].deep > target.deep) {
            findDescendants(i, rubrics[i - 1].rubric._id)
          } else if (rubrics[i].deep === target.deep) {
            final.push(
              {
                _id: rubrics[i].rubric._id,
                label: rubrics[i].rubric.label,
                total: rubrics[i].rubric.total,
                parent: parent,
                position: ++currentPosition
              })
          } else {
            i--
            break
          }
        }
      }
      findDescendants()
      return final.map(e => RubricManager.create(e))
    }
  }

})(window.angular, window._, window.moment)
